import {
  dynamicCreatePagesRoutesWithFilters,
  dynamicPagesRegexUpdateRoutesWithFilters,
  dynamicPagesRegexRoutesWithFiltersMap,
} from './constants';

export const isCreateDynamicPageWithFilters = () =>
  dynamicCreatePagesRoutesWithFilters.some(route => window.location.pathname === route);

export const isUpdateDynamicPageWithFilters = () =>
  dynamicPagesRegexUpdateRoutesWithFilters.some(regex => regex.test(window.location.pathname));

export const isActionDynamicPageWithFilters = () =>
  isCreateDynamicPageWithFilters() || isUpdateDynamicPageWithFilters();

export const getDynamicPageWithFiltersType = () => {
  // eslint-disable-next-line no-unused-vars
  const pageTypeObject = Object.entries(dynamicPagesRegexRoutesWithFiltersMap).find(([_type, regex]) =>
    regex.test(window.location.pathname)
  );

  return pageTypeObject?.[0];
};
